import React from "react";
import {useSwipeable} from "react-swipeable"
export default function Swipeable(props) {
    let {handlers, children, className, style} = props;
    const defaultHandlers = useSwipeable({
        onSwiped: (SwipeEventData) => {},
        onSwipedLeft: (SwipeEventData) => {},
        onSwipedRight: (SwipeEventData) => {},
        onSwipedUp: (SwipeEventData) => {},
        onSwipedDown: (SwipeEventData) => {},
        onSwipeStart: (SwipeEventData) => {},
        onSwiping: (SwipeEventData) => {},
        onTap: ({ event }) => {}
    })

    handlers = {...defaultHandlers, ...handlers}


    return (
        <div {...handlers} className={className} style={style}>
            {children}
        </div>
    )
}